import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isOurApiUrl } from '../utils/vanity-url.util';

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  constructor(@Inject(DOCUMENT) private doc: Document) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isMutating =
      req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH' || req.method === 'DELETE';
    const isOurApi = isOurApiUrl(req.url);
    if (!isMutating || !isOurApi) {
      return next.handle(req);
    }

    const token = this.readCookie('XSRF-TOKEN');
    const headers = token ? req.headers.set('X-CSRF-Token', token) : req.headers;
    const cloned = req.clone({ headers, withCredentials: true });
    return next.handle(cloned);
  }

  private readCookie(name: string): string | null {
    const m = this.doc.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'),
    );
    return m ? decodeURIComponent(m[1]) : null;
  }
}
